import {  
    getFirestore, 
    doc,
    deleteDoc
} from "firebase/firestore";
const removeQuiz = async function(quizId) {

    let db = getFirestore();
    const docRef = doc(db, "wellness_quiz", quizId);
    await deleteDoc(docRef)
};

export default removeQuiz;
